export default __webpack_public_path__ + "static/media/domino_counter_screen_1.9cc74fa6.png";